import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';

import { InputField } from '../../../ui/input-field/input-field';
import { Button } from '../../../ui/button/button';
import { Modal } from '../../../../core/services/modal';

@Component({
  selector: 'app-reject-user-account',
  imports: [TranslatePipe, CommonModule, Button, InputField, ReactiveFormsModule],
  templateUrl: './reject-user-account.html',
  styleUrl: './reject-user-account.css'
})
export class RejectUserAccount {
  @Input() options?: any;

  rejectForm: FormGroup;

  constructor(private modalService: Modal, private fb: FormBuilder,
    private router: Router
  ) {
    this.rejectForm = this.fb.group({
      reason: ['Outdated information', [Validators.required, Validators.minLength(3), Validators.maxLength(60)]]
    });
  }

  submitForm() {
    this.router.navigate(['/user-management'], { state: { payload: { showUserAccountStatus: true, title: 'USER_MANAGEMENT.USER_REJECTED_SUCCESS', subTitle: 'USER_MANAGEMENT.USER_CREATION_REJECTED_TEXT' } } });
    this.close();
  }

  close(): void {
    this.modalService.close();
  }

  get reasonControl(): FormControl {
    return this.rejectForm.get('reason') as FormControl;
  }
}
